<template>
    <div class="s2w-workspace-container">
        <div class="s2w-workspace-group-list">
            <template v-for="group in groups">
                <div
                    v-if="group.workspaces.length"
                    :key="group.type"
                    class="s2w-workspace-group-item"
                    @click="group.expand = !group.expand"
                >
                    <div class="s2w-workspace-group-item-pane">
                        <PtIcon
                            class="s2w-workspace-group-expand-icon"
                            style="font-size: 24px;"
                            :icon="group.expand ? 'SolidDropdownOpen' : 'SolidDropdownRight'"
                        />
                        <span>{{ $t(`BaseSaveToWorkspace.FolderSelector.workspaceGroupType.${group.type}`) }}</span>
                    </div>
                    <div
                        v-if="group.expand"
                        class="s2w-workspace-group-workspace-item"
                        @click.stop
                    >
                        <WorkspaceItem
                            v-for="workspace in group.workspaces"
                            :key="workspace.space_id"
                            :workspace="workspace"
                        />
                    </div>
                </div>
            </template>
        </div>
        <div
            v-if="selectedWorkspace"
            class="s2w-workspace-folder-list"
        >
            <div
                v-if="isFolderLoading"
                class="loading-pane"
            >
                <PtIcon
                    icon="SolidLoadingBars"
                    style="font-size: 48px;"
                />
            </div>
            <template v-else>
                <FolderTree
                    v-if="selectedWorkspace.folderTreeData && selectedWorkspace.folderTreeData.length"
                    :folders="selectedWorkspace.folderTreeData"
                />
                <div
                    v-else
                    class="no-data-pane"
                >
                    <PtIcon
                        icon="SolidNoDataTip"
                        style="font-size: 40px;"
                    />
                    <div>{{ $t('BaseSaveToWorkspace.FolderSelector.noData.folder') }}</div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import PtIcon from '@patsnap-biz/icon';
import get from 'lodash/get';
import WorkspaceItem from './WorkspaceItem';
import FolderTree from './FolderTree';
import '@patsnap-ui/icon/assets/solid/DropdownOpen.svg';
import '@patsnap-ui/icon/assets/solid/DropdownRight.svg';
import '@patsnap-ui/icon/assets/solid/NoDataTip.svg';
import '@patsnap-ui/icon/assets/solid/LoadingBars.svg';

export default {
    name: 'SaveToWorkspaceWorkspaceList',
    components: {
        WorkspaceItem,
        FolderTree,
        PtIcon,
    },
    inject: ['service'],
    computed: {
        selectedWorkspace() {
            return this.service.folderSelector.selectedWorkspace;
        },
        groups() {
            return this.service.folderSelector.workspaceGroupList;
        },
        isFolderLoading() {
            return get(this.selectedWorkspace, 'isLoading');
        },
    },
};
</script>
